/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * Creates an product card recommended tag instance
 *
 * @module enervee_utils.product_card
 */
function productCardRecommendedTagDirective() {
    return {
        restrict: 'E',
        bindToController: true,
        scope: {
            product: '=',
            type: '@',

        },
        controller: productCardRecommendedTagController,
        controllerAs: 'vm',
        template: require('./recommendedTagView.html')
    };
}

productCardRecommendedTagController.$inject = ['CategoriesService', 'CmsContentService'];
function productCardRecommendedTagController (CategoriesService, CmsContentService) {
    this.$onInit = () => {
        const vm = this;
        vm.popoverOpen = false;
        vm.popoverTemplate ='/common_utils/popovers/recommendedTagPopover.html';
        vm.category = CategoriesService.getActiveCategory();

        vm.popoverTitleCmsKey = `product_card:${vm.type}_recommended_tag_popover_title`;
        CmsContentService.getMarketPlaceText(
            vm.popoverTitleCmsKey,
            {},
            vm.category.id
        ).then((text) => {
            vm.popoverTitle = text;
        });

        vm.popoverBodyCmsKey = `product_card:${vm.type}_recommended_tag_popover_body`;
        CmsContentService.getMarketPlaceText(
            vm.popoverBodyCmsKey,
            {},
            vm.category.id
        ).then((text) => {
            vm.popoverBody = text;
        });
    }
}

module.exports = productCardRecommendedTagDirective;